import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Tiny pagination control.
 * Props: total, limit, offset, onChange(offset).
 * Renders nothing if there's only one page.
 */
export function Pagination({ total, limit, offset, onChange }) {
  if (!total || total <= limit) return null;
  const page = Math.floor(offset / limit) + 1;
  const pages = Math.ceil(total / limit);
  const start = offset + 1;
  const end = Math.min(offset + limit, total);

  return (
    <div className="pagination">
      <span className="pagination-info">
        <strong>{start}-{end}</strong> of <strong>{total}</strong>
      </span>
      <div className="pagination-buttons">
        <button
          className="ghost"
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - limit))}
          title="Previous page"
        >
          <ChevronLeft size={14} strokeWidth={2.5} />
        </button>
        <span className="pagination-page">Page {page} / {pages}</span>
        <button
          className="ghost"
          disabled={end >= total}
          onClick={() => onChange(offset + limit)}
          title="Next page"
        >
          <ChevronRight size={14} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
